import { phoneInvalidMessageMap, nonApprovedCountryMap } from './errorDictionary';
import { isValidPhoneNumber, phoneIsNotBlacklisted } from '../../utils/fieldValidators';
import useValidators from './useValidators';
function useValidPhone() {
    const errorMessageMap = [nonApprovedCountryMap, phoneInvalidMessageMap];
    const validators = [phoneIsNotBlacklisted, isValidPhoneNumber];
    return useValidators(errorMessageMap, validators);
}
export default useValidPhone;
